import React from 'react';
import P, { InferProps } from 'prop-types';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { Link } from 'react-router-dom';
import { Typography } from '@mui/material';
import { breadcrumbs } from '../../../utils/breadcrumbs';
import { SxStyle } from '../../../types';

const styles: SxStyle = {
  paper: (theme) => ({
    margin: theme.spacing(2),
  }),
};

function BreadCrumbs({ path }: InferProps<typeof BreadCrumbs.propTypes>) {
  return (
    <Breadcrumbs aria-label="breadcrumb" sx={styles.paper}>
      <Link style={{ textDecoration: 'none' }} to="/time-machine">
        /
      </Link>
      {breadcrumbs(path).map((part) => (
        <Link
          style={{ textDecoration: 'none' }}
          key={part.path}
          to={`/time-machine/${encodeURIComponent(part.path.substr(1))}`}
        >
          {part.part}
        </Link>
      ))}
      <Typography>{path.split('/').pop()}</Typography>
    </Breadcrumbs>
  );
}

BreadCrumbs.propTypes = {
  path: P.string.isRequired,
};

export default BreadCrumbs;
